import(/* webpackMode: "eager" */ "/var/www/node/intl/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/var/www/node/intl/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/var/www/node/intl/public/articles.jpg");
import(/* webpackMode: "eager" */ "/var/www/node/intl/src/components/common/HtmlParser.tsx");
import(/* webpackMode: "eager" */ "/var/www/node/intl/src/components/common/next/NextImage.tsx")